import React, { useEffect, useState, useRef } from "react";

import styled from "styled-components";

import { useTheme } from "../../Context/ThemeContext";
import { lightTheme, darkTheme } from "../../Styles/theme";
import TeacherBox from "./TeacherBox";
import UserProfile from '../Normal/UserProfile';

import { ReactComponent as LeftArrowSvg } from '../../image/LeftArrow.svg';

export default function TeacherSelectBox(props) {
  const { teachers, selectedTeachers, setSelectedTeachers } = props;
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [isClickedSelectBox, setIsClickedSelectBox] = useState(false);
  const [coachSelectBoxHeight, setCoachSelectBoxHeight] = useState(0);

  const TopLevelRef = useRef();

  // 선택창 크기 계산 //
  useEffect(() => {
    if (teachers.length > 5) setCoachSelectBoxHeight(155);
    else setCoachSelectBoxHeight(teachers.length * 32);
  }, [teachers])

  // 컴포넌트 밖을 클릭하면 셀렉트 창 닫기 //
  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);
    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [])

  // 컴포넌트 밖을 클릭하면 셀렉트 창 닫기
  function onClickOutSide(e) {
    if (TopLevelRef.current !== e.target && !TopLevelRef.current.contains(e.target)) {
      setIsClickedSelectBox(false);
    }
  }

  function onClickTeacherBox(data) {
    const selectedIndex = selectedTeachers.findIndex((teacher) => teacher.teacherId === data.teacherId);

    if (selectedIndex === -1) setSelectedTeachers([...selectedTeachers, data]);
    else setSelectedTeachers(selectedTeachers.filter((_, index) => index !== selectedIndex));
  }

  const overflowCount = selectedTeachers.length - 2;

  return (
    <TopLevelWrapper ref={TopLevelRef}>
      <SelectView
        isClicked={isClickedSelectBox}
        onClick={() => setIsClickedSelectBox(!isClickedSelectBox)}>
        <DefaultView>
          <SelectedCoachBoxWrapper>
            {selectedTeachers.slice(0, 2).map((data, index) => (
              <SelectedCoachBox key={'SelectedTeacher-' + index} $hasOverflow={overflowCount > 0}>
                <SelectedCoachWarpper>
                  <CoachProfileWrapper>
                    <UserProfile profile={data.profile} defaultProfile='https://picture.link-zone.org/ZoneLogo.png' />
                  </CoachProfileWrapper>
                  <CoachNameInner>
                    <CoachNameText>{data.teacherName}</CoachNameText>
                  </CoachNameInner>
                </SelectedCoachWarpper>
              </SelectedCoachBox>
            ))}
            {overflowCount > 0 && (
              <OverflowChip>
                <CoachNameInner $full>
                  <CoachNameText>{`+ ${overflowCount}`}</CoachNameText>
                </CoachNameInner>
              </OverflowChip>
            )}
          </SelectedCoachBoxWrapper>
          <ArrowIcon isClicked={isClickedSelectBox} />
        </DefaultView>
      </SelectView>
      <CoachSelectBox isClicked={isClickedSelectBox} height={isClickedSelectBox ? coachSelectBoxHeight : 0}>
        {
          teachers.map((data, index) => (
            <TeacherBox
              key={'TeacherBox-' + index}
              data={data}
              index={index}
              isLast={teachers.length === (index + 1)}
              isClicked={selectedTeachers.some((teacher) => teacher.teacherId === data.teacherId)}
              onClickTeacherBox={onClickTeacherBox} />
          ))
        }
      </CoachSelectBox>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  height: 32px;
`;

const SelectView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 0px 10px 0 5px;

  box-sizing: border-box;
  width: 100%;
  height: 32px;

  border: 1px solid ${props => props.theme.line};
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom-left-radius: ${props => props.isClicked ? `0px` : `5px`};
  border-bottom-right-radius: ${props => props.isClicked ? `0px` : `5px`};

  background-color: ${props => props.theme.subBackground};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const ArrowIcon = styled(LeftArrowSvg)`
  transform: ${props => props.isClicked ? 'rotate(90deg)' : 'rotate(-90deg)'};

  width: 8px;
  height: 13px;

  flex-shrink: 0;
  color: ${props => props.theme.line};

  pointer-events: none;
  transition: transform 0.3s ease-in-out;
`;

const DefaultView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  min-width: 0;
  
  gap: 10px;
`;

const SelectedCoachBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  flex: 1;
  min-width: 0;

  gap: 5px;
`;

const SelectedCoachBox = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  flex: ${props => props.$hasOverflow ? 1 : '0 1 auto'};
  min-width: 0;

  height: 21px;

  border-radius: 3px;
  overflow: hidden;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const OverflowChip = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  flex-shrink: 0;

  height: 21px;

  border-radius: 3px;
  overflow: hidden;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const SelectedCoachWarpper = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  width: 100%;
  min-width: 0;
  height: 21px;
`;

const CoachProfileWrapper = styled.div`
  width: 21px;
  height: 21px;

  flex-shrink: 0;

  border-radius: 3px 0 0 3px;
  overflow: hidden;
`;

const CoachNameInner = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  padding: 0px 10px 0px 5px;

  flex: 1;
  min-width: 0;
  height: 21px;

  border-radius: ${props => props.$full ? '3px' : '0 3px 3px 0'};
  background-color: ${props => props.theme.buttonFill};
`;

const CoachNameText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const CoachSelectBox = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  margin-top: 32px;

  width: calc(100% - 2px);
  height: ${props => props.height}px;

  border-left: 1px solid ${props => props.theme.line};
  border-right: 1px solid ${props => props.theme.line};
  border-bottom: ${props => props.isClicked ? `1px solid ${props.theme.line}` : `0px`};
  border-bottom-left-radius: ${props => props.isClicked ? `5px` : `0px`};
  border-bottom-right-radius: ${props => props.isClicked ? `5px` : `0px`};

  background-color: ${props => props.theme.subBackground};
  z-index: 10;

  overflow-x: hidden;
  overflow-y: scroll;

	&::-webkit-scrollbar {
		width: 0px;
	}

	&::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px ${props => props.theme.line};
		border: 3px solid transparent;
		height: 25px;
		border-radius: 200px;
	}

	&::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px 10px transparent;
		border: 4px solid transparent;
		background-color: transparent;
	}

	&::-webkit-scrollbar-track-piece {
		background-color: transparent;
	}

  transition: all 0.3s ease-in-out;
`;

